import GamesCustom from './GamesCustom';

export default GamesCustom;
